// import { useQuery } from '@tanstack/vue-query'
//一般的模块都直接用http即可
export default {
	// getByIdNew(id) {
	// 	//尝试useQuery
	// 	let qkey = '/event/getById/' + id
	// 	return useQuery(
	// 		[qkey],
	// 		async () => {
	// 			return await this.http.get(qkey, {}).then((res) => res.json())
	// 		},
	// 		{
	// 			retry: 3,
	// 			staleTime: 10000,
	// 			cacheTime: 20000
	// 		}
	// 	)
	// },
	getById(id, cb) {
		this.http.get(`/event/getById/${id}`, {}).then((r) => cb && cb(r))
	},
	status(id, to, cb, ecb) {
		this.http
			.get(`/event/status/${id}/${to}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getUserEnrollment(id, uid, status, cb) {
		this.http
			.get(`/event/getUserEnrollment/${id}/${uid}/${status}`, {})
			.then((r) => cb && cb(r))
	},
	getEnrollmentById(eid, cb, ecb) {
		this.http
			.get(`/event/getEnrollmentById/${eid}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	markEnrollment(eeid, cb, ecb) {
		this.http
			.post(`/event/markEnrollment/${eeid}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	countEnrollment(id, cb) {
		this.http
			.get(`/event/countEnrollment/${id}`, {})
			.then((r) => cb && cb(r))
	},
	enroll(form, cb, ecb) {
		this.http
			.post('/event/enroll/', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb) {
		this.http.get('/event/search/', { params }).then((r) => cb && cb(r))
	},
	update(e, cb, ecb, config = {}) {
		this.http
			.post('/event/update', e, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
